import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import dayjs from "dayjs";

export const formattedTs = (ts) => {
	return dayjs(ts).format("ddd, MMM D, h:mm A");
};

export const MardownText = ({ type, text }) => {
	return type === "user" ? (
		<ReactMarkdown
			components={{
				p: "div",
			}}
			children={text}
		></ReactMarkdown>
	) : (
		<ReactMarkdown
			children={text}
			linkTarget="_blank"
			remarkPlugins={[remarkGfm]}
			components={{
				p: "div",
			}}
		></ReactMarkdown>
	);
};
